<template>
  <Dashboard
    title="VDRC Flyfood Ordering"
    :authentication="authentication"
    :navbar="navbarElements"
    logo
  >
    <router-view>
      <!-- Magically inserts current routing content. SPAs rock! -->
    </router-view>

    <Row>
      <!-- Spacer for footer -->
      <spacer style="height: 100px"></spacer>
    </Row>

    <template #footer>
      <Row class="align-center">
        <Column cols="12" sm="5">
          &copy; {{ new Date().getFullYear() }} - Strategic Information Management Facility of VBCF
        </Column>

        <Column cols="12" sm="2" class="text-center">
        </Column>

        <Column cols="12" sm="5" class="text-right">
          <v-btn text dark href="https://vbc.atlassian.net/servicedesk/customer/portal/7" target="_blank">
            Get Support
            <Icon right>mdi-face-agent</Icon>
          </v-btn>
        </Column>
      </Row>
    </template>
  </Dashboard>
</template>

<script>
import authentication from "./utils/authentication";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["user"]),
    navbarElements: {
      get() {
        if (this.user) {
          return this.navbar.filter(item =>
            item.permissions
              ? this.user.permissions.some(p => item.permissions.includes(p))
              : true
          );
        }
        return [];
      }
    }
  },
  data: () => ({
    authentication,
    filteredNavbar: null,
    navbar: [
      { title: "Home", icon: "mdi-home", path: "/" }
    ]
  })
};
</script>
